export const FETCH_CORELAB_RESULTS_REQUESET = "FETCH_CORELAB_RESULTS_REQUESET";
export const FETCH_CORELAB_RESULTS_SUCCESS = "FETCH_CORELAB_RESULTS_SUCCESS";
export const FETCH_CORELAB_RESULTS_FAILURE = "FETCH_CORELAB_RESULTS_FAILURE";